import { render, staticRenderFns } from "./select-custom.vue?vue&type=template&id=4eb73545&scoped=true"
import script from "./select-custom.vue?vue&type=script&lang=js"
export * from "./select-custom.vue?vue&type=script&lang=js"
import style0 from "./select-custom.vue?vue&type=style&index=0&id=4eb73545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb73545",
  null
  
)

export default component.exports